import { FunctionComponent, ReactNode } from 'react';

import { Job } from '@kanda-libs/ks-frontend-services';

import CardPaymentFormProvider from './Context';
import CardPaymentFormElements from './Elements';
import CardPaymentFormWrapper from './Wrapper';

interface CardPaymentFormProps {
  job?: Job;
  showActionRequired?: boolean;
  title?: string;
  buttonLabel?: string;
  showMobileTitle?: boolean;
  customHeading?: ReactNode;
}

const CardPaymentForm: FunctionComponent<CardPaymentFormProps> = (props) => (
  <CardPaymentFormProvider {...props}>
    <CardPaymentFormWrapper>
      <CardPaymentFormElements />
    </CardPaymentFormWrapper>
  </CardPaymentFormProvider>
);

export default CardPaymentForm;
